import { languageMap } from ".."

languageMap.rest = {
	comments: {
		line: "..",
	},
}
